const routes = {
  index: {
    path: 'index.invoicing',
    url: 'facturation',
  },
}

export default routes



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/invoicing/routes.js